module.exports = __webpack_public_path__ + "static/media/pitcherthumbnail.9bac081f.png";